import React from 'react';

export function Tag({ children, variant = 'default', dot = false }) {
  const textValue = typeof children === 'string' ? children.trim().toLowerCase().replace(/\s+/g, '_') : '';

  const statusVariantMap = {
    active: 'ok',
    completed: 'ok',
    hold: 'warn',
    on_hold: 'warn',
    planned: 'info'
  };

  const resolvedVariant = statusVariantMap[textValue] || variant;

  return <span className={`tag tag-${resolvedVariant} ${dot ? 'tag-dot' : ''}`}>{children}</span>;
}